import React, { useEffect } from "react";
import { useDispatch, connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { fetchTradingAccounts } from "store/actions";
import ItemsDropDown from "../ItemsDropDown";

function AccountsDropDown({ ...props }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchTradingAccounts({
      customerId: props.customerId,
      limit: 1000,
      page: 1,
    }));
  }, []);

  let optionGroup = props.accounts.map((obj) => {
    return ({
      label: `${obj.login} (${obj.type})`,
      value: obj.login
    });
  });
  optionGroup.unshift({
    label: "All",
    value: ""
  });
  return (
    <React.Fragment>
      <ItemsDropDown
        options={optionGroup}
        lable={"Account Login"}
        defaultValue={props.defaultValue}
        elementChangeHandler={props.accountChangeHandler} />
    </React.Fragment>);
}

const mapStateToProps = (state) => ({
  accounts: state.tradingAccountReducer.accounts?.docs || [],
  customerId: state.clientReducer.clientDetails._id,
});

export default connect(mapStateToProps, null)(withTranslation()(AccountsDropDown));